import 'intersection-observer';
import createPage from  '@/create-page';
import boostShare from '@/views/share/boost/index.vue';

createPage({
    meta: {
        fullscreen: false,
    },
    component: boostShare,
    checkForbidden: false,
} );
